export default __webpack_public_path__ + "static/video-93c509c5929e2fb2803af59e7463e817.mp4";